import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import { BackToTopLink } from './BackToTopLink.client';
export function H2Wrapper(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      borderTopRightRadius: "16px",
      borderTopLeftRadius: "16px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <BackToTopLink />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <Box display="flex" justifyContent="space-between" borderBottom="4px solid" borderColor="greens.main" bgcolor="greens.extraLight" padding={3} marginBottom={3} gap={2} sx={t1}>{children}{t2}</Box>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}